import React, { Component } from 'react';
import './GraphView.scss';
import { bootsrapColours, colours, CScolours } from '../../../config'
import {getTabTotals} from '../../helpers'
import ChartBar from '../ChartBar'
import ChartPie from '../ChartPie'
import ChartLine from '../ChartLine'

class GraphView extends Component {

    constructor(props) {
        super(props);
        this.state = {
          costSaleTab: 0,
        }
    };

    costSaleTab (index) {
      this.setState({costSaleTab: index})
    }

    render() {

        const valArr = []

        let costPie = []
        let salePie = []

        const ChartBarData = this.props.job.map((item, i) => {
          let it = item.items ? item.items : []
          const totalCost = it.map((doc, i) => {
            const quantity = doc.quantity ? doc.quantity : 1
            const cost = doc.cost ? quantity * doc.cost : 0
            return cost
          }).reduce((a, b) => a + b, 0).toFixed(2)
          const totalSale = it.map((doc, i) => {
            const quantity = doc.quantity ? doc.quantity : 1
            const sale = doc.sale ? quantity * doc.sale : 0
            return sale
          }).reduce((a, b) => a + b, 0).toFixed(2)
          costPie.push({"id": item.name, "label": item.name, "value": totalCost})
          salePie.push({"id": item.name, "label": item.name, "value": totalSale})
          valArr.push(totalCost, totalSale)
          return {
            "tabs": item.name,
            "Cost": Number(totalCost),
            "Sale": Number(totalSale),
            "Profit": Number(totalSale) - Number(totalCost)
          }
        })

        let max = Math.max(...valArr)

        return (
          <div className='graph-view'>

            <div className='row'>
              <div className="col-sm-12">
                <div className='panel panel-info'>
                  <div className='panel-heading'>
                    Sale & Cost
                  </div>
                    <div className='panel-body'>
                      <ChartBar height={300} maxValue={max + (max / 10)} data={ChartBarData} keys={["Cost","Sale"]} colors={CScolours} />
                    </div>
                  </div>
                </div>
            </div>


            <div className='row'>
              <div className="col-sm-5">


                <div className='panel panel-info panel-tab tab-br' style={{borderTopLeftRadius: 11, background: 'none', border: 'none'}}>
                  <div className="panel-heading" style={{borderTopLeftRadius: 10, background: 'none', border: 'none'}}>
                    Sale & Cost
                  </div>
                  <div className="panel-body">
                    <div name="tab_name" className="tabs">
                      <ul>
                        <li className={(this.state.costSaleTab === 0 ? 'active' : '')}>
                          <a style={{background: CScolours[0]}} onClick={this.costSaleTab.bind(this, 0)}>Cost</a>
                        </li>
                        <li className={(this.state.costSaleTab === 1 ? 'active' : '')}>
                          <a style={{background: CScolours[0]}} onClick={this.costSaleTab.bind(this, 1)}>Sale</a>
                        </li>
                      </ul>
                      <div className='pi-charts'>
                          <div>
                            {this.state.costSaleTab === 0 &&
                              <ChartPie height={280} data={costPie}/>
                            }
                            {this.state.costSaleTab === 1 &&
                              <ChartPie height={280} data={salePie}/>
                            }
                          </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <div className="col-sm-7">
                <div className='panel panel-info'>
                  <div className='panel-heading'>
                    Profit
                  </div>
                    <div className='panel-body'>
                      <ChartBar height={300} maxValue={max + (max / 10)} data={ChartBarData} keys={["Profit"]} colors={[CScolours[2]]} />
                    </div>
                  </div>
                </div>
            </div>




          </div>
        )
    }
}



//
//   <div className='col-sm-5'>
//
//

//
//     </div>
//
//   </div>
//
//   <div className='col-sm-7'>
//     <div className='panel panel-info'>
//       <div className='panel-heading' >
//         Profit
//       </div>
//         <div className="panel-body">
//           <ChartBar height={300} data={dataProfit} maxValue={1500} keys={["Cost"]} colors={[CScolours[1], CScolours[1]]} />
//         </div>
//     </div>
//   </div>
//
// </div>

export default GraphView;



// WEBPACK FOOTER //
// ./src/views/components/GraphView/index.js